module.exports = __webpack_public_path__ + "static/img/prod_pic11.0d0cbf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/prod_pic11.jpg
// module id = J43y
// module chunks = 5